var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPrintWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 5.375V1.375C4.375 1.09886 4.59886 0.875 4.875 0.875H12.875C13.1511 0.875 13.375 1.09886 13.375 1.375V5.375M4.375 5.375H13.375M4.375 5.375H2.58211C2.12935 5.375 1.69514 5.55486 1.375 5.875C1.05486 6.19514 0.875 6.62935 0.875 7.08211V11.375C0.875 11.6511 1.09886 11.875 1.375 11.875H4.375M13.375 5.375H15.1679C15.6206 5.375 16.0549 5.55486 16.375 5.875C16.6951 6.19514 16.875 6.62935 16.875 7.08211V11.375C16.875 11.6511 16.6511 11.875 16.375 11.875H13.375M13.375 11.875V15.875C13.375 16.1511 13.1511 16.375 12.875 16.375H4.875C4.59886 16.375 4.375 16.1511 4.375 15.875V11.875M13.375 11.875V9.875H4.375V11.875",
    stroke: "#FFF",
    strokeWidth: 1.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.125,
    cy: 7.625,
    r: 0.25,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrintWhite);
export default __webpack_public_path__ + "static/media/icon-print-white.571a3c637ae2b7168dc42e04084a916c.svg";
export { ForwardRef as ReactComponent };